module.exports = __webpack_public_path__ + "img/sliderBtnRight.71467091.svg";